import { render } from "./EntrySlider.vue?vue&type=template&id=32ba992e"
import script from "./EntrySlider.vue?vue&type=script&lang=ts"
export * from "./EntrySlider.vue?vue&type=script&lang=ts"
script.render = render

export default script